export const contactsData = {
    email: 'ahanbandyopadhyay@gmail.com',
    phone: '+918305117960',
    address: 'Flat no. 104, Silver Estate Apartments, University Road, Gwalior, M.P. India, 474011',

    sheetAPI: ''
}